module.exports = __webpack_public_path__ + "static/media/line-cook.76dcc7b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/line-cook.jpg
// module id = 563
// module chunks = 0